import type { LucideIcon } from 'lucide-react';
import {
  BarChart3,
  Briefcase,
  Code2,
  Compass,
  Facebook,
  Github,
  Globe2,
  Instagram,
  Linkedin,
  MapPin,
  Mail,
  MessageCircle,
  Music2,
  PenTool,
  Radio,
  Rocket,
  Search,
  Send,
  Youtube
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  BarChart3,
  Briefcase,
  Code2,
  Compass,
  Facebook,
  Github,
  Globe2,
  Instagram,
  Linkedin,
  MapPin,
  Mail,
  MessageCircle,
  Music2,
  PenTool,
  Radio,
  Rocket,
  Search,
  Send,
  Youtube
};

export function getIcon(name: string): LucideIcon {
  return iconMap[name] ?? Globe2;
}
